import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarSequenceService {

  constructor(private http: HttpClient) { }

  /**
   * Get car trip by giving arguments.
   * @param model Argument model
   */
  getCarTrip(model: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/car/carTrip`;
    return this.http.post(url, model, { responseType: 'text' });
  }

  getCarSeqOptions(model: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/car/carSeqOptions`;
    return this.http.post(url, model);
  }
}
